module.exports = __webpack_public_path__ + "static/media/clara-logo.ca2a4409.jpeg";